import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import invariant from 'invariant';
import { CameraType, ImageType } from "./CameraModule.types";
import * as Utils from "./CameraUtils";
import * as CapabilityUtils from "./CapabilityUtils";
import { isBackCameraAvailableAsync, isFrontCameraAvailableAsync } from "./UserMediaManager";
import { FacingModeToCameraType, PictureSizes } from "./constants";
export { ImageType, CameraType };
var VALID_SETTINGS_KEYS = ['autoFocus', 'flashMode', 'exposureCompensation', 'colorTemperature', 'iso', 'brightness', 'contrast', 'saturation', 'sharpness', 'focusDistance', 'whiteBalance', 'zoom'];

var CameraModule = function () {
  function CameraModule(videoElement) {
    var _this = this;

    _classCallCheck(this, CameraModule);

    this.videoElement = videoElement;

    this.onCameraReady = function () {};

    this.onMountError = function () {};

    this.stream = null;
    this.settings = null;
    this.isStartingCamera = false;
    this.cameraType = CameraType.front;
    this.webCameraSettings = {
      autoFocus: 'continuous',
      flashMode: 'off',
      whiteBalance: 'continuous',
      zoom: 1
    };

    this.getAvailablePictureSizes = function _callee(ratio) {
      return _regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", PictureSizes);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, null, null, null, Promise);
    };

    this.getAvailableCameraTypesAsync = function _callee2() {
      var devices, types;
      return _regeneratorRuntime.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (navigator.mediaDevices.enumerateDevices) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", []);

            case 2:
              _context2.next = 4;
              return _regeneratorRuntime.awrap(navigator.mediaDevices.enumerateDevices());

            case 4:
              devices = _context2.sent;
              _context2.t0 = _regeneratorRuntime;
              _context2.t1 = Promise;
              _context2.next = 9;
              return _regeneratorRuntime.awrap(isFrontCameraAvailableAsync(devices));

            case 9:
              _context2.t2 = _context2.sent;

              if (!_context2.t2) {
                _context2.next = 12;
                break;
              }

              _context2.t2 = CameraType.front;

            case 12:
              _context2.t3 = _context2.t2;
              _context2.next = 15;
              return _regeneratorRuntime.awrap(isBackCameraAvailableAsync());

            case 15:
              _context2.t4 = _context2.sent;

              if (!_context2.t4) {
                _context2.next = 18;
                break;
              }

              _context2.t4 = CameraType.back;

            case 18:
              _context2.t5 = _context2.t4;
              _context2.t6 = [_context2.t3, _context2.t5];
              _context2.t7 = _context2.t1.all.call(_context2.t1, _context2.t6);
              _context2.next = 23;
              return _context2.t0.awrap.call(_context2.t0, _context2.t7);

            case 23:
              types = _context2.sent;
              return _context2.abrupt("return", types.filter(Boolean));

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, null, null, null, Promise);
    };

    if (this.videoElement) {
      this.videoElement.addEventListener('loadedmetadata', function () {
        _this.syncTrackCapabilities();
      });
    }
  }

  _createClass(CameraModule, [{
    key: "updateWebCameraSettingsAsync",
    value: function updateWebCameraSettingsAsync(nextSettings) {
      var changes, _i, _Object$keys, key, nextValue, hasChanges;

      return _regeneratorRuntime.async(function updateWebCameraSettingsAsync$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              changes = {};
              _i = 0, _Object$keys = Object.keys(nextSettings);

            case 2:
              if (!(_i < _Object$keys.length)) {
                _context3.next = 11;
                break;
              }

              key = _Object$keys[_i];

              if (VALID_SETTINGS_KEYS.includes(key)) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("continue", 8);

            case 6:
              nextValue = nextSettings[key];

              if (nextValue !== this.webCameraSettings[key]) {
                changes[key] = nextValue;
              }

            case 8:
              _i++;
              _context3.next = 2;
              break;

            case 11:
              hasChanges = !!Object.keys(changes).length;
              this.webCameraSettings = _objectSpread(_objectSpread({}, this.webCameraSettings), changes);

              if (!hasChanges) {
                _context3.next = 16;
                break;
              }

              _context3.next = 16;
              return _regeneratorRuntime.awrap(this.syncTrackCapabilities(changes));

            case 16:
              return _context3.abrupt("return", hasChanges);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "setTypeAsync",
    value: function setTypeAsync(value) {
      return _regeneratorRuntime.async(function setTypeAsync$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(value === this.cameraType)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              this.cameraType = value;
              _context4.next = 5;
              return _regeneratorRuntime.awrap(this.resumePreview());

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "setPictureSize",
    value: function setPictureSize(value) {
      if (value === this.pictureSize) {
        return;
      }

      invariant(PictureSizes.includes(value), "expo-camera: CameraModule.setPictureSize(): invalid size supplied " + value + ", expected one of: " + PictureSizes.join(', '));
      this.pictureSize = value;
    }
  }, {
    key: "isTorchAvailable",
    value: function isTorchAvailable() {
      return isCapabilityAvailable(this.videoElement, 'torch');
    }
  }, {
    key: "isZoomAvailable",
    value: function isZoomAvailable() {
      return isCapabilityAvailable(this.videoElement, 'zoom');
    }
  }, {
    key: "onCapabilitiesReady",
    value: function onCapabilitiesReady(track) {
      var _this2 = this;

      var settings,
          capabilities,
          constraints,
          clampedValues,
          _i2,
          _clampedValues,
          property,
          _validatedConstrainedValue,
          _args5 = arguments;

      return _regeneratorRuntime.async(function onCapabilitiesReady$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              settings = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              capabilities = track.getCapabilities();
              constraints = {};
              clampedValues = ['exposureCompensation', 'colorTemperature', 'iso', 'brightness', 'contrast', 'saturation', 'sharpness', 'focusDistance', 'zoom'];

              for (_i2 = 0, _clampedValues = clampedValues; _i2 < _clampedValues.length; _i2++) {
                property = _clampedValues[_i2];

                if (capabilities[property]) {
                  constraints[property] = convertNormalizedSetting(capabilities[property], settings[property]);
                }
              }

              _validatedConstrainedValue = function _validatedConstrainedValue(key, propName, converter) {
                return validatedConstrainedValue(key, propName, converter(settings[propName]), capabilities, settings, _this2.cameraType);
              };

              if (capabilities.focusMode && settings.autoFocus !== undefined) {
                constraints.focusMode = _validatedConstrainedValue('focusMode', 'autoFocus', CapabilityUtils.convertAutoFocusJSONToNative);
              }

              if (capabilities.torch && settings.flashMode !== undefined) {
                constraints.torch = _validatedConstrainedValue('torch', 'flashMode', CapabilityUtils.convertFlashModeJSONToNative);
              }

              if (capabilities.whiteBalanceMode && settings.whiteBalance !== undefined) {
                constraints.whiteBalanceMode = _validatedConstrainedValue('whiteBalanceMode', 'whiteBalance', CapabilityUtils.convertWhiteBalanceJSONToNative);
              }

              _context5.next = 11;
              return _regeneratorRuntime.awrap(track.applyConstraints({
                advanced: [constraints]
              }));

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, null, null, null, Promise);
    }
  }, {
    key: "applyVideoConstraints",
    value: function applyVideoConstraints(constraints) {
      return _regeneratorRuntime.async(function applyVideoConstraints$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(!this.stream || !this.stream.getVideoTracks)) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return", false);

            case 2:
              _context6.next = 4;
              return _regeneratorRuntime.awrap(applyConstraints(this.stream.getVideoTracks(), constraints));

            case 4:
              return _context6.abrupt("return", _context6.sent);

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "applyAudioConstraints",
    value: function applyAudioConstraints(constraints) {
      return _regeneratorRuntime.async(function applyAudioConstraints$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!(!this.stream || !this.stream.getAudioTracks)) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return", false);

            case 2:
              _context7.next = 4;
              return _regeneratorRuntime.awrap(applyConstraints(this.stream.getAudioTracks(), constraints));

            case 4:
              return _context7.abrupt("return", _context7.sent);

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "syncTrackCapabilities",
    value: function syncTrackCapabilities() {
      var _this3 = this;

      var settings,
          _args8 = arguments;
      return _regeneratorRuntime.async(function syncTrackCapabilities$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              settings = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};

              if (!(this.stream && this.stream.getVideoTracks)) {
                _context8.next = 4;
                break;
              }

              _context8.next = 4;
              return _regeneratorRuntime.awrap(Promise.all(this.stream.getVideoTracks().map(function (track) {
                return _this3.onCapabilitiesReady(track, settings);
              })));

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "setStream",
    value: function setStream(stream) {
      this.stream = stream;
      this.settings = stream ? stream.getTracks()[0].getSettings() : null;
      setVideoSource(this.videoElement, stream);
    }
  }, {
    key: "getActualCameraType",
    value: function getActualCameraType() {
      if (this.settings) {
        var _this$settings$facing = this.settings.facingMode,
            facingMode = _this$settings$facing === void 0 ? 'user' : _this$settings$facing;
        return FacingModeToCameraType[facingMode];
      }

      return null;
    }
  }, {
    key: "ensureCameraIsRunningAsync",
    value: function ensureCameraIsRunningAsync() {
      return _regeneratorRuntime.async(function ensureCameraIsRunningAsync$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (this.stream) {
                _context9.next = 3;
                break;
              }

              _context9.next = 3;
              return _regeneratorRuntime.awrap(this.resumePreview());

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "resumePreview",
    value: function resumePreview() {
      var stream;
      return _regeneratorRuntime.async(function resumePreview$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (!this.isStartingCamera) {
                _context10.next = 2;
                break;
              }

              return _context10.abrupt("return", null);

            case 2:
              this.isStartingCamera = true;
              _context10.prev = 3;
              this.stopAsync();
              _context10.next = 7;
              return _regeneratorRuntime.awrap(Utils.getStreamDevice(this.type));

            case 7:
              stream = _context10.sent;
              this.setStream(stream);
              this.isStartingCamera = false;
              this.onCameraReady();
              return _context10.abrupt("return", stream);

            case 14:
              _context10.prev = 14;
              _context10.t0 = _context10["catch"](3);
              this.isStartingCamera = false;
              this.onMountError({
                nativeEvent: _context10.t0
              });

            case 18:
              return _context10.abrupt("return", null);

            case 19:
            case "end":
              return _context10.stop();
          }
        }
      }, null, this, [[3, 14]], Promise);
    }
  }, {
    key: "takePicture",
    value: function takePicture(config) {
      var base64 = Utils.captureImage(this.videoElement, config);
      var capturedPicture = {
        uri: base64,
        base64: base64,
        width: 0,
        height: 0
      };

      if (this.settings) {
        var _this$settings = this.settings,
            _this$settings$width = _this$settings.width,
            width = _this$settings$width === void 0 ? 0 : _this$settings$width,
            _this$settings$height = _this$settings.height,
            height = _this$settings$height === void 0 ? 0 : _this$settings$height;
        capturedPicture.width = width;
        capturedPicture.height = height;
        capturedPicture.exif = this.settings;
      }

      if (config.onPictureSaved) {
        config.onPictureSaved({
          nativeEvent: {
            data: capturedPicture,
            id: config.id
          }
        });
      }

      return capturedPicture;
    }
  }, {
    key: "stopAsync",
    value: function stopAsync() {
      stopMediaStream(this.stream);
      this.setStream(null);
    }
  }, {
    key: "type",
    get: function get() {
      return this.cameraType;
    }
  }]);

  return CameraModule;
}();

function stopMediaStream(stream) {
  if (!stream) return;
  if (stream.getAudioTracks) stream.getAudioTracks().forEach(function (track) {
    return track.stop();
  });
  if (stream.getVideoTracks) stream.getVideoTracks().forEach(function (track) {
    return track.stop();
  });
  if (isMediaStreamTrack(stream)) stream.stop();
}

function setVideoSource(video, stream) {
  try {
    video.srcObject = stream;
  } catch (_) {
    if (stream) {
      video.src = window.URL.createObjectURL(stream);
    } else if (typeof video.src === 'string') {
      window.URL.revokeObjectURL(video.src);
    }
  }
}

function applyConstraints(tracks, constraints) {
  return _regeneratorRuntime.async(function applyConstraints$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return _regeneratorRuntime.awrap(Promise.all(tracks.map(function _callee3(track) {
            return _regeneratorRuntime.async(function _callee3$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.next = 2;
                    return _regeneratorRuntime.awrap(track.applyConstraints({
                      advanced: [constraints]
                    }));

                  case 2:
                  case "end":
                    return _context11.stop();
                }
              }
            }, null, null, null, Promise);
          })));

        case 3:
          return _context12.abrupt("return", true);

        case 6:
          _context12.prev = 6;
          _context12.t0 = _context12["catch"](0);
          return _context12.abrupt("return", false);

        case 9:
        case "end":
          return _context12.stop();
      }
    }
  }, null, null, [[0, 6]], Promise);
}

function isCapabilityAvailable(video, keyName) {
  var stream = video.srcObject;

  if (stream instanceof MediaStream) {
    var videoTrack = stream.getVideoTracks()[0];

    if (typeof videoTrack.getCapabilities === 'undefined') {
      return false;
    }

    var _capabilities = videoTrack.getCapabilities();

    return !!_capabilities[keyName];
  }

  return false;
}

function isMediaStreamTrack(input) {
  return typeof input.stop === 'function';
}

function convertNormalizedSetting(range, value) {
  if (!value) return;
  var converted = convertRange(value, [range.min, range.max]);
  return Math.min(range.max, Math.max(range.min, converted));
}

function convertRange(value, r2) {
  var r1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [0, 1];
  return (value - r1[0]) * (r2[1] - r2[0]) / (r1[1] - r1[0]) + r2[0];
}

function validatedConstrainedValue(constraintKey, settingsKey, convertedSetting, capabilities, settings, cameraType) {
  var setting = settings[settingsKey];

  if (Array.isArray(capabilities[constraintKey]) && convertedSetting && !capabilities[constraintKey].includes(convertedSetting)) {
    console.warn(" { " + settingsKey + ": \"" + setting + "\" } (converted to \"" + convertedSetting + "\" in the browser) is not supported for camera type \"" + cameraType + "\" in your browser. Using the default value instead.");
    return undefined;
  }

  return convertedSetting;
}

export default CameraModule;